import api from "../apiConfig";

export const ApiList = async () => {
  try {
    const resp = await api.get("/api/apikey/list");
    return resp;
  } catch (error) {
    console.log("APi Key 리스트 가져오기 Error ", error);
    return error;
  }
};
